import { MRT_ColumnDef } from 'mantine-react-table'
import { Text, } from '@mantine/core'
import { ReactNode } from 'react'
import { TradedFacilityParams } from 'app/models/traded-facilities-params'
import { formatPriceWithoutCurrency } from 'app/utils/util-functions'
import { facilityStatusInfo } from '../../trade-enty-page-columnDefs'

function TableHead({ header, textAlign }: { header: string, textAlign?: 'start' | 'end' | 'center' }) {
    return (
        <Text
            style={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '16px',
                fontWeight: 700,
                lineHeight: '22px',
                color: '#413E3E',
                textAlign: textAlign ?? 'center',
                width: '100%',
            }}
        >
            {header}
        </Text>
    )
}

function TableRowText({ text, textAlign }: { text: ReactNode, textAlign?: 'start' | 'center' | 'end' }) {
    return (
        <Text
            style={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '15px',
                fontWeight: 600,
                lineHeight: '19px',
                color: '#413E3E',
                textAlign: textAlign ?? 'center',
            }}
        >
            {text}
        </Text>
    )
}


export const columnDefs: MRT_ColumnDef<TradedFacilityParams>[] = [

    {
        size: 160,
        accessorKey: 'facilityDetails.name',
        header: 'Facility Name',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Facility name'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign="start" />,

    },
    {
        size: 80,
        accessorKey: 'facilityDetails.status',
        header: 'Facility Status',
        mantineTableHeadCellProps: {
            className: 'cell-width-80',
        },

        Header: <TableHead header={'Facility Status'} textAlign='start' />,
        Cell: ({ cell }) => {
            const info = facilityStatusInfo[cell.getValue() as string]
            if (!info) return null
            return (
                <Text
                    style={{
                        fontFamily: 'Plus Jakarta Sans',
                        fontSize: '15px',
                        fontWeight: 600,
                        lineHeight: '19px',
                        color: info.color,
                        textAlign: 'start',
                    }}
                >
                    {info.display}
                </Text>
            )
        },
    },
    {
        size: 50,
        accessorKey: 'facilityDetails.facilityType',
        header: 'Facility Type',
        mantineTableHeadCellProps: {
            className: 'cell-width-50',
        },

        Header: <TableHead header={'Facility Type'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign="start" />,

    },
    {
        size: 50,
        accessorKey: 'facilityDetails.baseCurrency',
        header: 'Currency',
        mantineTableHeadCellProps: {
            className: 'cell-width-50',
        },

        Header: <TableHead header={'Currency'} />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} />,
    },
    {
        size: 100,
        accessorKey: 'tradeAmount',
        header: 'Trade Amount',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Trade Amount'} textAlign='end' />,
        Cell: ({ cell }) => {
            const amount = cell.getValue() as string ?? ''
            return <TableRowText textAlign='end' text={formatPriceWithoutCurrency(Number(amount), 2, 2) ?? ''} />
        },
    },
    {
        size: 100,
        accessorKey: 'amounts',
        header: 'amounts',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Current Amount'} textAlign='end' />,
        Cell: ({ cell }) => {
            const amounts = cell.getValue() as any[] ?? []
            if (amounts.length > 0) {
                const amount = amounts[amounts.length - 1].amount
                return <TableRowText textAlign='end' text={formatPriceWithoutCurrency(Number(amount), 2, 2) ?? ''} />
            }
            return <TableRowText text={''} />
        },

    },
    {
        size: 100,
        accessorKey: 'price',
        header: 'Price',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Price'} textAlign='end' />,
        Cell: ({ cell }) => {
            const price = cell.getValue() as string ?? ''
            return <TableRowText textAlign='end' text={formatPriceWithoutCurrency(Number(price), 10, 10) ?? ''} />
        },

    },
    {
        size: 100,
        accessorKey: 'facilityDetails.cusip',
        header: 'CUSIP',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'CUSIP'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign='start' />,
    },
    {
        size: 100,
        accessorKey: 'facilityDetails.lxId',
        header: 'LX ID',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'LX ID'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign='start' />,
    },


    {
        size: 100,
        accessorKey: 'facilityDetails.systemId',
        header: 'Facility ID',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Facility ID'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign='start' />,

    },

    {
        size: 100,
        accessorKey: 'facilityDetails.clientId',
        header: 'Client Facility ID',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },

        Header: <TableHead header={'Client Facility ID'} textAlign='start' />,
        Cell: ({ cell }) => <TableRowText text={cell.getValue() as string ?? ''} textAlign='start' />,

    },

]